import { Box, Typography } from '@material-ui/core'
import { Button } from 'react-bootstrap/lib/InputGroup'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core'
import { verifyUserProfile } from '../../actions'
import { useDispatch } from 'react-redux'
import { Check } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  container: {
    padding: '5rem',
    width: '80rem',
    margin: '5rem auto'
  },
  title: {
    color: '#FFFFFF',
    backgroundColor: '#9D3EB3',
    fontSize: '2rem',
    padding: '1rem',
    textAlign: 'center',
    fontWeight: 600
  },
  message: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '2rem',
    alignItems: 'center',
    textAlign: 'center',
    lineHeight: '3.5rem',
    padding: '3rem 10rem',
    backgroundColor: '#FFFFFF'
  },
  button: {
    marginTop: '3rem',
    backgroundColor: '#9D3EB3',
    width: 'fit-content',
    color: '#FFFFFF',
    padding: '1.5rem 5rem',
    borderRadius: '10rem',
    '&:hover': {
      cursor: 'pointer'
    },
    boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.25)'
  },
  isVerified: {
    padding: '1rem 1.5rem',
    width: 'fit-content',
    borderRadius: '5rem'
  },
  text: {
    fontSize: '1.4rem',
    fontWeight: 600,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    color: '#0B7070'
  },
  checkIcon: {
    backgroundColor: '#0B7070',
    borderRadius: '50%',
    marginRight: '1rem',
    display: 'flex',
    width: 'fit-content',
    padding: '.3rem'
  }
}))

const VerificationInfoMessage = ({ isVerified }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()

  const doVerification = () => {
    dispatch(verifyUserProfile())
  }

  return (
    <>
      {!isVerified ? (
        <Box className={classes.container}>
          <Typography className={classes.title}>
            {t('profile.verificationInfoMessageTitle')}
          </Typography>
          <Typography className={classes.message}>
            {t('profile.verificationInfoMessage')}
            <Button className={classes.button} onClick={() => doVerification()}>
              {t('profile.verificationInfoMessageBtn')}
            </Button>
          </Typography>
        </Box>
      ) : (
        <Box className={classes.isVerified}>
          <Typography className={classes.text}>
            <span className={classes.checkIcon}>
              <Check
                style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  color: '#FFFFFF'
                }}
              />
            </span>
            {t('profile.profileIsVerified')}
          </Typography>
        </Box>
      )}
    </>
  )
}

export default VerificationInfoMessage
